import { createAsyncThunk } from '@reduxjs/toolkit';
import { updatePassValidationCompStatus } from '..';
import { ActionStatus } from '../../../common/constants/action-status';
import { PassValidationCompStatus } from '../../../common/constants/api-constants';
import getCookie, { COOKIE_MH_TOKEN } from '../../../common/cookies';
import { StoreState } from '../../../store/store.interface';
import { clearLoginCustomerState } from '../../customer/customer';
import { putUserProfile } from '../api/put-user-profile';
import { selectUser, selectPassword, getUpdateProfileAffiliations } from '../user-profile.selectors';
import { fetchUserProfile } from '../user-profile.thunks';
import { handleApiError, ApiError } from '../../../common/utils/api-utils';

export const updateUserProfile = createAsyncThunk(
  'userProfile/updateUserProfile',
  async (updatedUserInfo: any, thunkAPI) => {
    try {
      const hasMHTokenCookie = getCookie(COOKIE_MH_TOKEN);

      if (!hasMHTokenCookie) {
        thunkAPI.dispatch(clearLoginCustomerState());
        return null;
      }

      const state = thunkAPI.getState() as StoreState;
      const userProfileInfo = selectUser(state);
      const affiliations = getUpdateProfileAffiliations(state);
      const password = selectPassword(state);
      await putUserProfile({
        ...userProfileInfo,
        password,
        ...updatedUserInfo,
        affiliations
      });
      await thunkAPI.dispatch(fetchUserProfile({ forceUpdate: true }));
      await thunkAPI.dispatch(updatePassValidationCompStatus(PassValidationCompStatus.default));
      return true;
    } catch (error) {
      console.error(error);
      if (error instanceof ApiError) {
        handleApiError(error);
      }
      return thunkAPI.rejectWithValue(error);
    }
  },
  {
    condition: (_arg, { getState }) => {
      const state = getState() as StoreState;
      return state.userProfileState.userProfileResponse.status !== ActionStatus.loading;
    },
  }
);
